import Vue from 'vue'
import VueRouter from 'vue-router'
import KitFilter from '../views/KitFilter.vue'
import KitDetails from '../views/KitDetails.vue'
import KitCompare from '../views/KitCompare.vue'
import ContentPage from '../views/ContentPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'KitFilter',
    component: KitFilter
  },
  {
    path: '/details',
    name: 'KitDetails',
    component: KitDetails
  },
  {
    path: '/compare',
    name: 'KitCompare',
    component: KitCompare
  },
  {
    path: '/page/:handle',
    name: 'ContentPage',
    component: ContentPage,
    props: true
  }
]

const router = new VueRouter({
  routes
})

export default router
